function VehicleCoverTypeTransformer(jsonMapper, util, quoteOptions) {
	function transform(intermediateRequest, coverTypeDescriptor) {

		intermediateRequest.vehicles[0].coverType =  coverTypeDescriptor;

		return intermediateRequest;
	}

	return {
		transform: transform
	}
}
